import { render, staticRenderFns } from "./OperaWorkorderWindow.vue?vue&type=template&id=fa473b84&"
import script from "./OperaWorkorderWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWorkorderWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports